import $axios from '../api.js'
import Axios from 'axios'

const state = () => ({

})

const mutations = {
    
}

const actions = {
    submit({ commit }, payload) {
        localStorage.setItem('token', null)
        commit('SET_TOKEN', null, { root: true })
        return new Promise((resolve, reject) => {
            $axios.post('/login', payload)
            .then((response) => {
                //if (response.data.status == 'success') {
                    localStorage.setItem('token', response.data.success.token)
                    commit('SET_TOKEN', response.data.success.token, { root: true })
                    Axios.defaults.headers.common['Authorization'] = 'Bearer ' + response.data.success.token
                //} else if (response.data.status == 'failed'){
                    //commit('SET_ERRORS', { invalid: 'Email/Password Salah' }, { root: true })
                //}
                resolve(response.data)
            })
            .catch((error) => {
                if (error.response.status == 401) {
                    commit('SET_ERRORS', { invalid: 'Email/Password Salah' }, { root: true })
                }
            })
        })
    }
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}